<h1 mat-dialog-title>
  {{ (isEdit ? 'PROJECT.FINANCIAL_CAPEX.EDIT_ITEM' : 'PROJECT.FINANCIAL_CAPEX.ADD_ITEM') | anessaTranslation: trigger }}
</h1>
<mat-dialog-content>
  <form #capexForm="ngForm">
    <div class="flex-container">
      <div class="flex-box border-shadow">
        <h3 class="compact-header-margin" anessaTranslation="PROJECT.FINANCIAL_CAPEX.NAME"></h3>
        <mat-form-field>
          <input
            matInput
            type="text"
            id="name"
            name="name"
            required
            disabled
            [(ngModel)]="capex.name">
        </mat-form-field>
      </div>
    </div>
    <div class="flex-container">
      <div class="flex-box border-shadow">
        <h3 class="compact-header-margin" anessaTranslation="PROJECT.FINANCIAL_CAPEX.COST"></h3>
        <app-unit-value [units]="'Currency'"
                        name="cost"
                        [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
                        [dropdownPlaceholder]="('PROJECT.COMMON.CHOOSE' | anessaTranslation: trigger)"
                        [(ngModel)]="capex.cost">
        </app-unit-value>
      </div>
      <div class="flex-box border-shadow">
        <h3 class="compact-header-margin" anessaTranslation="PROJECT.FINANCIAL_CAPEX.LIFETIME"></h3>
        <app-unit-value [units]="'Period'"
                        [disableUnit]="true"
                        [setGreaterThanValue]="0"
                        name="period"
                        [inputPlaceholder]="('PROJECT.COMMON.PLEASE_ENTER' | anessaTranslation: trigger)"
                        [dropdownPlaceholder]="('PROJECT.COMMON.CHOOSE' | anessaTranslation: trigger)"
                        [(ngModel)]="capex.lifetime">
        </app-unit-value>
      </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="fatbuttongroup">
  <button
    mat-button
    class="btn-fat btn-green"
    type="button"
    (click)="onSaveClick()"
    anessaTranslation="PROJECT.COMMON.SAVE">
  </button>
  <button
    mat-button
    class="btn-fat btn-red"
    type="button"
    (click)="onCancelClick()"
    anessaTranslation="PROJECT.COMMON.CANCEL">
  </button>
</mat-dialog-actions>
